import React, { useState, useEffect } from 'react';
import { Provider } from 'react-redux';
import { LoadingIndicator } from '@ihsm/ui-shared';
import FontFaceObserver from 'fontfaceobserver';
import { ToastContainer } from 'react-toastify';
import { ToastCloseButton } from 'shared/components/Notification';
import { FONT_FACE_OBSERVER_TIMEOUT, FONT_LIST } from 'shared/constants/';
import { store } from 'state/store';
import { AppServiceBootStrap } from 'shared/containers/AppServiceBootStrap/AppServiceBootStrap';
import { StoredThemeProvider } from 'shared/components/StoredThemeProvider/StoredThemeProvider';
import { RoutesWithAuth } from './RoutesWithAuth';
import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.dark.css';
import 'react-toastify/dist/ReactToastify.css';

const fontObservers = FONT_LIST.map((font) => new FontFaceObserver(font));

export const RootComponent = (): JSX.Element => {
  const [fontsLoaded, setFontsLoaded] = useState(false);

  useEffect(() => {
    if (!fontsLoaded) {
      Promise.all(
        fontObservers.map((observer) =>
          observer.load(null, FONT_FACE_OBSERVER_TIMEOUT)
        )
      )
        .catch(() => {
          throw new Error('Error while loading fonts');
        })
        .finally(() => {
          setFontsLoaded(true);
        });
    }
  }, [fontsLoaded]);

  if (!fontsLoaded) {
    return <LoadingIndicator />;
  }

  return (
    <Provider store={store}>
      <AppServiceBootStrap />
      <ToastContainer closeButton={ToastCloseButton} />

      <StoredThemeProvider>
        <RoutesWithAuth />
      </StoredThemeProvider>
    </Provider>
  );
};
